<template>
  <AppMenu v-if="menu.length" open-on-hover offset-y :menu="menu">
    <template v-slot:activator="{ props }">
      <app-button type="ghost" variant="neutral" data-locator="more-actions-bar-item" v-bind="props">
        {{ $t("common.app-action-bar.moreActionsButtonLabel") }}
        <template #left-icon>
          <app-material-icon name="more_horiz" color="inherit" />
        </template>
      </app-button>
    </template>
  </AppMenu>
</template>

<script>
import AppMenu from '@/common/AppMenu.vue'

export default {
  name: 'AppActionBarMoreActionsMenu',
  components: {
    AppMenu,
  },
  props: {
   menu: {
     type: Array,
     required: true,
   },
  },
}
</script>
